import { defineComponent as n } from "vue";
import o from "./index581.js";
import e from "./index582.js";
const a = n({
  name: "MsTextLink",
  components: { SvgAnchor: o, SvgArrow: e },
  props: {
    isCopyLink: Boolean,
    hasAnchorIcon: Boolean,
    hasClickArea: Boolean,
    isIndex: Boolean,
    hyphensEnabled: Boolean,
    isTruncated: Boolean,
    href: { default: null, type: String },
    target: { default: null, type: String },
    rel: { default: null, type: String },
    suffix: { default: null, type: String },
    sign: String,
    isPRG: Boolean
  }
});
export {
  a as default
};
